export default {"src":"/_next/static/media/illustrationBackground.bc3f9e72.svg","height":91,"width":740};